import React from 'react'
import { injectState } from 'freactal'
import app from '../../../../feathers'
import { hasElement, sectionDisplayIndex } from '../../../../lib'
import { Checkbox } from 'react-mdl'

const units = app.service('units')
class SummativeTheoryContent extends React.Component {
  state = {
    summativeTheoryMapping: [],
  }

  componentDidMount() {
    this.initialMapping()
  }

  componentWillReceiveProps() {
    this.initialMapping()
  }

  initialMapping = () => {
    const theoryQuestionsBySection = (section, sectionIndex) => {
      const questionsArr = []
      const processSection = (
        { subsections = [], questions = [] },
        sectionIndex,
      ) => {
        const reviewQuestions = questions.reduce((carry, question, i) => {
          if (question.type === 'final') {
            carry.push({
              mapping: question.mapping,
              questionIndex: i,
              sectionIndex,
            })
          }
          return carry
        }, [])
        questionsArr.push(...reviewQuestions)
        subsections.forEach((section, j) =>
          processSection(section, [...sectionIndex, j]),
        )
      }
      section.subsections.forEach((section, i) =>
        processSection(section, [...sectionIndex, i]),
      )
      return questionsArr
    }
    const questionsBySections = this.props.state.unit.sections.map(
      (section, i) => theoryQuestionsBySection(section, [i]),
    )
    const allFinalQuestions = questionsBySections.reduce(
      (carry, sectionQuestions) => carry.concat(sectionQuestions),
      [],
    )
    this.setState({ summativeTheoryMapping: allFinalQuestions })
  }

  handleChangeTheoryMapping = async (e, sectionIndex, questionIndex) => {
    const { _id } = this.props.state.unit
    const { unitElement } = this.props
    const isChecked = e.target.checked
    const op = isChecked ? '$push' : '$pull'
    await units.patch(_id, {
      [op]: {
        [`sections.${sectionIndex.join(
          '.subsections.',
        )}.questions.${questionIndex}.mapping`]: unitElement,
      },
    })
  }

  render() {
    const { summativeTheoryMapping } = this.state
    const { unitElement } = this.props
    return (
      <tbody>
        {summativeTheoryMapping.map(
          ({ mapping, sectionIndex, questionIndex }, i) =>
            <tr key={`summativeTheory-${i}`}>
              <td>
                <Checkbox
                  onChange={e =>
                    this.handleChangeTheoryMapping(
                      e,
                      sectionIndex,
                      questionIndex,
                    )}
                  checked={hasElement(unitElement, mapping)}
                />
              </td>
              <td>
                Question {i + 1}
              </td>
              <td>
                {sectionDisplayIndex(sectionIndex)}
              </td>
            </tr>,
        )}
      </tbody>
    )
  }
}

export default injectState(SummativeTheoryContent)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/MappingModal/SummativeTheoryContent.js